import { setUserInfo } from "@actions/profile.js";
import { showAlert } from "@components/alert/action";
import Loading from "@components/loading/index.jsx";
import { MainContext } from "@context";
import BonusesV2 from "@pages/profile-v2/pages/bonuses/index.js";
import Deposit from "@pages/profile-v2/pages/deposit/index.js";
import HistoryV2 from "@pages/profile-v2/pages/history-v2/index.js";
import ProfilePage from "@pages/profile-v2/pages/profile/ProfilePage.js";
import Withdraw from "@pages/profile-v2/pages/withdraw/index.js";
import Inbox from "@pages/profile/inbox.jsx";
import React, { useContext, useEffect, useState } from "react";
import { Translate } from "react-localize-redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import CloseIcon from "./assets/icons/CloseIcon.jsx";
import SidebarMenu from "./components/SidebarMenu";
import {
	Page,
	PageContent,
	PageContentWrapper,
	PageHeader,
	PageWithSidebar,
	PageWrapper,
	WithdrawWarning,
} from "./elements.js";
import Documents from "./pages/documents";
import DropdownMenu from "./pages/profile/components/DropdownMenu/index.js";

const ProfilePageV2 = ({ user, inbox, setUserInfo, showAlert, location, history, match }) => {
	const { isMobile, isTablet, isDesktop, isWide, isUltraWide } = useContext(MainContext).state;

	const [loading, setLoading] = useState(false);

	const [path, setPath] = useState(null);

	const toggleLoading = () => {
		setLoading(!loading);
	};

	//TODO: updateUserInfo is not used in the component, it should be used or removed
	const updateUserInfo = (username, payload) => {
		setUserInfo(username, payload, () => {
			setLoading(false);
		});
	};

	useEffect(() => {
		const wrapperMain = document.querySelector("#WrapperMain");
		if (wrapperMain) {
			wrapperMain.classList.add("profile-page");
		}
	}, []);

	useEffect(() => {
		if (location?.pathname) setPath(location.pathname);
	}, [location.pathname]);

	const renderContents = (path, translate) => {
		switch (path) {
			case "/profile/settings":
				return (
					<ProfilePage
						translate={translate}
						toggleLoading={toggleLoading}
						updateUserInfo={updateUserInfo}
						user={user}
						showAlert={showAlert}
					/>
				);
			case "/profile/inbox":
				return inbox ? <Inbox location={location} /> : null;
			case "/profile/documents":
				return <Documents translate={translate} />;
			case "/profile/history":
				return <HistoryV2 />;
			case "/profile/bonuses":
				return <BonusesV2 />;
			case "/profile/deposit":
				return (
					<Deposit
						location={location}
						history={history}
						match={match}
					/>
				);
			case "/profile/withdraw":
				return (
					<Withdraw
						location={location}
						history={history}
						match={match}
					/>
				);
			default:
				return (
					<ProfilePage
						translate={translate}
						toggleLoading={toggleLoading}
						updateUserInfo={updateUserInfo}
						user={user}
						showAlert={showAlert}
					/>
				);
		}
	};
	return (
		<Translate>
			{({ translate }) => (
				<PageWrapper isColorful={window.IS_BOARD_WRAPPER_COLORFUL}>
					{loading && <Loading loading={loading} />}
					<PageWithSidebar>
						{(isWide || isUltraWide) && (
							<SidebarMenu
								isWithdrawOrDepositPage={
									path === "/profile/deposit" || path === "/profile/withdraw"
								}
							/>
						)}
						<Page>
							<PageHeader>
								{(isDesktop || isMobile || isTablet) && (
									<DropdownMenu
										translate={translate}
										location={location}
									/>
								)}
								<Link
									to="/"
									data-testid={
										path === "/profile/deposit" || path === "/profile/withdraw"
											? "button-deposit-close"
											: "button-profile-close"
									}>
									<CloseIcon />
								</Link>
							</PageHeader>
							{path === "/profile/withdraw" && (
								<WithdrawWarning>
									{translate(window.WITHDRAW_WARNING)}
								</WithdrawWarning>
							)}
							<PageContentWrapper>
								<PageContent>{renderContents(path, translate)}</PageContent>
								<div id="navigation-btns"></div>
							</PageContentWrapper>
						</Page>
					</PageWithSidebar>
				</PageWrapper>
			)}
		</Translate>
	);
};

const mapStateToProps = (state) => ({
	user: state.profile.user,
	inbox: state.profile.inbox,
});

const mapDispatchToProps = {
	setUserInfo,
	showAlert,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePageV2);
